import React from "react";

const SvgIcon = ({ src, color = "black", size = 50 }) => {
    const styles = {
        width: size,
        height: size,
        backgroundColor: color,
        WebkitMask: `url(${src}) no-repeat center / contain`,
        mask: `url(${src}) no-repeat center / contain`,
    };

    return <div style={styles} />;
};


export default SvgIcon;
